/**
 * UI presented on
 * - lost password
 * - account validation
 */

import {Component, Mixins} from "vue-property-decorator";
import {AuthScreenMixin} from "~/modules/auth/views/auth-screen-mixins";
import {EmailStepMessages} from "~/modules/auth/components/email-step";
import {ChangePasswordPasswordStep} from "~/modules/auth/components/change-password-password-step";
import {ChangePasswordEmailStep} from "~/modules/auth/components/change-password-email-step";
import {SignUpPasswordStep} from "~/modules/auth/components/signup-password-step";
import {PasswordStepMessage} from "~/modules/auth/components/change-password-step";

type ChangePasswordMessageDefinition = {
  [key: string]: {
    email: EmailStepMessages,
    password: PasswordStepMessage,
  }
}

const messages: ChangePasswordMessageDefinition = {
  lostPassword: {
    email: {
      title: "Mot de passe oublié",
      description: "Veuillez renseigner votre adresse email pour débuter la réinitialisation de votre mot de passe.",
      success: "Votre demande de réinitialisation de mot de passe a été prise en compte et un email vous a été envoyé",
      error: "Erreur lors votre demande de réinitialisation de mot de passe. Veuillez contacter le support.",
    },
    password: {
      title: "Réinitialisation du mot de passe",
      description: "Veuillez renseigner votre nouveau mot de passe.",
      error: "Erreur lors de la sauvegarde du mot de passe. Veuillez contacter le support.",
      success: "Votre nouveau mot de passe a été sauvegardé avec succès.",
    }
  },
  accountActivation : {
    email: {
      title: "Activation de compte",
      description: "Veuillez renseigner votre adresse email pour initier la procédure d'activation de compte.",
      success: "Votre demande d'activation de compte a été prise en charge et un email vous a été envoyé",
      error: "Erreur lors votre demande d'activation de compte. Veuillez contacter le support."
    },
    password: {
      title: "Création du mot de passe",
      description: "Pour activer votre compte utilisateur, merci de renseigner un mot de passe.",
      error: "Erreur lors de l'activation du compte. Veuillez contacter le support.",
      success: "Votre compte a été activé avec succès",
    }
  }
};

@Component
class ChangePassword extends Mixins(AuthScreenMixin) {

  get processType(): "account-activation" | "lost-password" {
    if(this.$route.name === "account-activation" || this.$route.name === "lost-password") return this.$route.name;
    throw new Error("undeclared route");
  }

  get messages(){
    if( this.processType === "account-activation"){
      return messages.accountActivation;
    } else if( this.processType === "lost-password"){
      return messages.lostPassword;
    }
  }

  get isFromRegistration(): boolean {
    return this.$route.query.type === 'registration';
  }

  changePasswordStep() {
    return this.isFromRegistration ?
      <SignUpPasswordStep type={this.processType} messages={this.messages.password} code={this.code} /> :
      <ChangePasswordPasswordStep type={this.processType} messages={this.messages.password} code={this.code} />
  }

  renderStates() {
    return this.code ?
      this.changePasswordStep() :
      <ChangePasswordEmailStep type={this.processType} messages={this.messages.email} />;
  }

  render() {
    return this.wrapRenderer(() => (
      <div>
        <section class="change-password">
          <form>
            {this.renderLogoCustomization()}
            {this.renderStates()}
          </form>
          {this.renderPoweredBy()}
        </section>
      </div>
    ));
  }
}

export default ChangePassword;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-5d052d1b/change-password.tsx" });